import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ApiResponse } from 'src/app/shared/models/api-response.interface';
import { API_VERSIONS } from 'src/app/shared/consts/api-versions.const';

export interface StaffMember {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  avatar?: string;
}

@Injectable({
  providedIn: 'root',
})
export class StaffApiService {
  constructor(private apiService: HttpService) {}

  /**
   * Search staff members for mention suggestions
   * @param search - Search query (name or email)
   * @param limit - Maximum number of results
   */
  searchStaff(
    search: string,
    limit: number = 10
  ): Observable<ApiResponse<StaffMember[]>> {
    return this.apiService.getReq(
      `/${API_VERSIONS.USERS}/users/paging`,
      {
        params: {
          filter_by_group: 1, // Staff group
          search,
          length: limit,
        },
      }
    );
  }

  /**
   * Get all staff members (paginated)
   */
  getAllStaff(
    page: number = 1,
    length: number = 100
  ): Observable<ApiResponse<StaffMember[]>> {
    return this.apiService.getReq(
      `/${API_VERSIONS.USERS}/users/paging`,
      {
        params: {
          filter_by_group: 1, // Staff group
          page,
          length,
        },
      }
    );
  }
}

